export const JOB_RECOMMENDATION_SUBMIT_REQUEST = 'job/recommendations-submit-request'
export const JOB_RECOMMENDATION_SUBMIT_SUCCESS = 'job/recommendations-submit-success'
export const JOB_RECOMMENDATION_SUBMIT_FAILED = 'job/recommendations-submit-failed'
